import Created from './Created';
import Name from './Name';
import Updated from './Updated';

export const labels = {
  Name: 'Név',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
};

export const allColumns = [{
  value: 'Name',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Name',
  fixed: true,
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Created,
  Updated,
  Name,
};
